<style lang="less" scoped>
.class-info{
  margin:30px 50px;
  font-size:18px;
  position: relative;
  .content{
    font-size:1.1em;
    font-weight: bold;
    margin-bottom:10px;
    padding:10px 0;
    border-bottom:1px solid #EEE;
  }
  .tips1{
    position: absolute;
    color: #999;
    font-size: 16px;
    right: 0;
    top: 128px;
  }
  .tips2{
    position: absolute;
    color: #999;
    font-size: 16px;
    right: 0;
    top: 320px;
    border-bottom:1px solid #EEE;
  }
  .tips3{
    color: #999;
    font-size: 16px;
    align-content: center;
  }
  .text-wrapper_15 {
    border-radius: 4px;
    height: 35px;
    background: @primary-color;
    text-align: center;
  }

  .text_38 {
    height: 1.53vw;
    overflow-wrap: break-word;
    color: white;
    font-size: 1.11vw;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 1.53vw;
  }

  .edit{
    width: 80px;
    height:32px;
    border-radius:20px;
    color: #fff;
    font-size: 16px;
    background: @primary-color;
    float: right;
  }

  .classNumber {
    min-height: 260px;
    .classTop {
      .classGroup{
        /deep/.ant-col-4{
          margin-top: 6px;
        }
      }
    }
    }
}
</style>
<template>
  <div class="class-info">
    <div>班级名</div>
    <div class="content"  >{{classInfo.className||classInfo.groupname}}     <a-button class="edit" @click="addNewClass">编辑</a-button></div>
    <div>班级ID</div>
    <div class="content">{{classInfo.id||classInfo.groupid}}</div>
    <div class="tips1">网页端学生搜索班级ID加入班级</div>
    <div>班级二维码</div>
    <div class="content" ref="qrcode" style="border:none;"></div>
    <div class="tips2">手机端或Pad端可通过扫描二维码入班级</div>
    <div class="tips3">
      <a-button class="text-wrapper_15" @click="dissolveClass()"><span class="text_38">解散班级</span></a-button>
    </div>

    <a-modal class="classNumber" v-model="addClassModel" width="440px" title="修改班级名称" @ok="addNewClassFun"
             @cancel="cancelNewClass" destroyOnClose>
      <a-row class="classTop">
        <a-col :span="4" class="classGroup">班级名:</a-col>
        <a-col :span="20"><a-input class="newName" v-model="newClassName" /></a-col>
      </a-row>
    </a-modal>
  </div>

</template>

<script>
import QRCode from 'qrcodejs2'
import shareState from 'utils/shareState.js'
export default {
  name: 'ClassInfoClass',
  data () {
    return {
      shareData: shareState.state,
      classInfo: {},
      groupid: '',
      newClassName: '',
      addClassModel: false,
      qrcode: null
    }
  },
  watch: {
    $route () {
      this.getClassInfo()
    }
  },
  mounted () {
    this.getClassInfo()
  },
  methods: {
    getClassInfo () {
      this.groupid = this.$route.params.groupid
      const myClass = this.shareData.imGroupList.filter(c => c.groupTag === this.groupid)
      if (myClass.length === 0) {
        const myGroup = this.shareData.imGroupList.filter(g => g.groupTag === this.groupid)
        this.classInfo = myGroup.length > 0 ? myGroup[0] : {}
      } else {
        this.classInfo = myClass[0]
      }
      this.$nextTick(() => {
        this.creatQrCode(this.classInfo.id || this.classInfo.groupid)
      })
      this.newClassName = this.classInfo.className
      console.log('myClass', myClass)
      console.log('classInfo', this.classInfo)
    },
    creatQrCode (id) {
      if (this.qrcode) {
        this.qrcode.clear()
        this.qrcode.makeCode(id)
        return
      }
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: id, // 需要转换为二维码的内容
        width: 130,
        height: 130,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    dissolveClass () {
      // 解散班级
      const param = {
        classId: this.classInfo.id || this.classInfo.groupid
      }
      const _this = this
      _this.$confirm({
        title: '解散班级',
        content: '班级解散后发布的学习任务数据会同步删除,您确定解散班级吗？',
        okText: '确认',
        cancelText: '取消',
        onOk () {
          return new Promise((resolve, reject) => {
            _this
              .$fetch({
                url: _this.$httpConfig.dissolveClass,
                body: param
              })
              .done((res) => {
                resolve(res)
              })
          }).then((res) => {
            if (res && res.success && res.resultCode === 0) {
              _this.$message.success('解散成功')
              _this.$router.push({ name: 'AccompanyStudy' })
            }
          })
        },
        onCancel () {
        }
      })
    },
    addNewClass () {
      // 新建班级弹窗
      this.addClassModel = true
    },
    cancelNewClass () {
      this.addClassModel = false
    },
    addNewClassFun() {
      // 新建班级确定
      if(!this.newClassName || this.newClassName === '') {
        this.$message.warning('请您输入班级名称')
        return false
      }
      if (this.newClassName.length > 8) {
        this.$message.warning('请您输入班级名在8个汉字以内')
        return;
      }
      const param = {
        classId: this.classInfo.id || this.classInfo.groupid,
        name: this.newClassName
      }
      const _this = this;
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/editClassName',
        body: param
      })
        .loading(
          () => (_this.loading = true),
          () => (_this.loading = false)
        )
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.$message.success('修改班级名称成功')
            _this.addClassModel = false
            _this.classInfo.className = this.newClassName
          }
        })
    }
  }
}
</script>
